export const AccessoryStatus = {
    ADD: 1,
    REPLACE: 2,
    DELETE: 3,
};
Object.freeze(AccessoryStatus);

export class AccessoryCtrl {

    constructor({orderId, shop}) {
        this.orderId = orderId;
        this.shop = shop;
    }

    /**
     * Ajoute un accessoire au panier
     * @param idSeo idSeo de l'accessoire à ajouter
     * @return retourne une {Promise} pour l'ajout d'accessoire
     */
    async addAccessory(idSeo) {
        if (this.orderId == null) {
            return this.#initAccessoryCart(idSeo, this.shop)
                .then((response) => {
                    this.orderId = response.orderId
                    return this.#fetchCart(this.orderId).then((cart) => {
                        return { cartInfo: cart, cartUrl: response.tunnelUrl }
                    })
                })
        } else {
            return this.#addCrossSellAccessory(idSeo, this.orderId)
                .then((response) => {
                    return { cartInfo: response.cartInfo, cartUrl: response.cartUrl }
                })
        }
    }

    async deleteAccessory(idSeo) {
        return this.#deleteCrossSellAccessory(idSeo, this.orderId)
            .then((response) => {
                return { cartInfo: response.cartInfo, cartUrl: response.cartUrl }
            });
    }

    /**
     * Initialise le cart accessoire
     * @param idSeo idSeo de l'accessoire à ajouter
     * @param shop shop
     * @return retourne une {Promise} pour l'init card
     */
   #initAccessoryCart(idSeo, shop) {
        return new Promise((resolve, reject) => {
            const body = {
                idSeo: idSeo,
                shop: shop
            }
            $.ajax({
                method: "POST",
                xhrFields: {
                    withCredentials: true
                },
                url: "/api/mobile/order/accessory",
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify(body)
            }).done((data) => {
                resolve(data)
            }).fail((error) => {
                reject(error)
            });
        });
    }

    /**
     * Ajoute ou retire un accessoire x-sell ou bundle en session
     * @param idSeo id seo de l'accessoire à ajouter
     * @param orderId orderId du panier sur lequel ajouter l'accessoire
     * @return retourne une {Promise} pour la mise à jour de l'accessoire
     */
    #addCrossSellAccessory(idSeo, orderId) {
        return new Promise((resolve, reject) => {
            const body = {
                idSeo: idSeo
            }
            $.ajax({
                method: "POST",
                xhrFields: {
                    withCredentials: true
                },
                url: `/api/mobile/orders/${orderId}/accessories`,
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify(body)
            }).done((data) => {
                resolve(data)
            }).fail((error) => {
                reject(error)
            });
        });
    }

    /**
     * retire un accessoire x-sell ou bundle en session
     * @param idSeo id seo de l'accessoire à ajouter
     * @param orderId orderId du panier sur lequel supprimer l'accessoire
     * @return retourne une {Promise} pour la mise à jour de l'accessoire
     */
   #deleteCrossSellAccessory(idSeo, orderId) {
        return new Promise((resolve, reject) => {
            const body = {
                idSeo: idSeo,
                quantity: 0
            }
            $.ajax({
                method: "PUT",
                xhrFields: {
                    withCredentials: true
                },
                url: `/api/mobile/orders/${orderId}/accessories`,
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify(body)
            }).done((data) => {
                resolve(data)
            }).fail((error) => {
                reject(error)
            });
        });
    }

    #fetchCart(orderId) {

        let url =  `/api/mobile/orders/${orderId}/cartinfo`

        return new Promise((resolve, reject) => {
            $.ajax({
                method: "GET",
                url: url,
                contentType: "application/json",
            }).done(data => {
                resolve(data);
            }).fail(error => {
                reject(error);
            });
        });
    }
}
